import * as ActionTypes from './types.action';

export const getReportToken = () => ({
  type: ActionTypes.GET_REPORT_TOKEN_REQUESTED,
});
